import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './Container';
export function Nav() {
  return <nav className="sticky top-0 z-50 bg-brand-white border-b border-brand-gray300" data-id="element-163" data-mp="120z5jejyy6eh">
      <Container className="flex items-center justify-between py-[18px]" data-id="element-164" data-mp="16yr8d3m5jcxg">
        <Link to="/" className="font-black text-[20px] tracking-[-0.01em]" data-id="element-165" data-mp="1b0m5rx0yp65y">
          THE ABIE AGENCY
        </Link>
        <ul className="hidden md:flex gap-[32px] list-none max-[720px]:hidden" data-id="element-166" data-mp="1g079sluzo4pj">
          <li data-id="element-167" data-mp="1kys6ibb18698">
            <Link to="/#work" className="text-[14px] font-medium hover:text-brand-gray600 transition-colors" data-id="element-168" data-mp="1ky8okuldthv7">
              Work
            </Link>
          </li>
          <li data-id="element-169" data-mp="1uov0adpz9o8m">
            <Link to="/#services" className="text-[14px] font-medium hover:text-brand-gray600 transition-colors" data-id="element-170" data-mp="1unjxag4cwkik">
              Services
            </Link>
          </li>
          <li data-id="element-171" data-mp="23q1hkp0gb32x">
            <Link to="/influencers" className="text-[14px] font-medium hover:text-brand-gray600 transition-colors" data-id="element-172" data-mp="23pjeb8fdfoli">
              Influencers
            </Link>
          </li>
          <li data-id="element-173" data-mp="1u6pucjmgfr16">
            <Link to="/about" className="text-[14px] font-medium hover:text-brand-gray600 transition-colors" data-id="element-174" data-mp="1p50gkw7ukz9e">
              About
            </Link>
          </li>
          <li data-id="element-175" data-mp="2hto653zmqasr">
            <Link to="/#careers" className="text-[14px] font-medium hover:text-brand-gray600 transition-colors" data-id="element-176" data-mp="2hu7d5pnqres0">
              Careers
            </Link>
          </li>
          <li data-id="element-177" data-mp="283304vhmm3zt">
            <Link to="/contact" className="text-[14px] font-medium hover:text-brand-gray600 transition-colors" data-id="element-178" data-mp="282thjsywuz45">
              Contact
            </Link>
          </li>
        </ul>
      </Container>
    </nav>;
}